export enum LevelType {
  Low = "Low",
  Medium = "Medium",

  High = "High",

  VeryHigh = "Very High",
}
